module.exports = __webpack_public_path__ + "static/media/Gårdsten vårdcentral use telemedicine software for digital healthcare.3b38ad43.webp";